import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 72 — HubSpot specialist-role & cost cluster service links.
 *
 * Every Batch 72 article routes its primary commercial link to
 * /hubspot-revops-architect. The answer-first leads in batch72Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /hubspot-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH72_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "hire-hubspot-onboarding-specialist": {
    url: "/hubspot-revops-architect",
    anchor:
      /portal set up in a wizard with no lifecycle map is a portal the workflow breaks/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hire-hubspot-automation-specialist": {
    url: "/hubspot-revops-architect",
    anchor:
      /workflow that fires on every form submit with no branching is a workflow the team rekeys/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-admin-cost": {
    url: "/hubspot-revops-architect",
    anchor:
      /part-time admin who skips the maintenance is a hire the broken workflow punishes/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-implementation-cost": {
    url: "/hubspot-revops-architect",
    anchor:
      /basic setup with no workflow build is a portal the team rekeys at the first deal/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-retainer-cost": {
    url: "/hubspot-revops-architect",
    anchor:
      /maintenance retainer with no growth scope is a retainer the team outgrows at the first campaign/i,
    label: "hire a HubSpot RevOps architect",
  },
};
